import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { FilterChips, PageHero, SignalBars, formatDate } from "@/components/site/parts";
import { useCopy } from "@/lib/copy";

export default function Blog() {
  const t = useCopy();
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tag, setTag] = useState("All");

  useEffect(() => {
    api.get("/blog").then(({ data }) => setPosts(data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const tags = useMemo(() => {
    const counts = {};
    posts.forEach((p) => (p.tags || []).forEach((t) => { counts[t] = (counts[t] || 0) + 1; }));
    const top = Object.keys(counts).sort((a, b) => counts[b] - counts[a]).slice(0, 5);
    return ["All", ...top];
  }, [posts]);
  const shown = tag === "All" ? posts : posts.filter((p) => p.tags?.includes(tag));

  return (
    <>
      <PageHero
        kicker={t("blog.kicker")}
        title={t("blog.title")}
        accent={t("blog.accent")}
        sub={t("blog.sub")}
      />
      <section className="bx" style={{ paddingTop: 40 }}>
        <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "space-between", alignItems: "center", gap: 16, marginBottom: 20 }}>
          {tags.length > 2 ? <FilterChips label="Filter by tag" options={tags} value={tag} onChange={setTag} /> : <span />}
          <span className="kicker">{shown.length} POSTS</span>
        </div>
        <div className="card" style={{ borderRadius: 24, overflow: "hidden" }}>
          {loading ? (
            <p className="kicker" style={{ padding: 32 }}>Loading posts…</p>
          ) : shown.length === 0 ? (
            <div style={{ padding: "56px 32px", display: "flex", flexDirection: "column", gap: 8 }}>
              <span className="disp" style={{ fontSize: 24, fontWeight: 800, textTransform: "uppercase" }}>{t("blog.empty_title")}</span>
              <span style={{ fontSize: 16, color: "#4A4F5A" }}>{t("blog.empty_body")}</span>
            </div>
          ) : (
            shown.map((p, k) => (
              <Link key={p.id} to={`/blog/${p.slug}`} className="post-row" style={{ padding: "26px 32px", borderTop: k === 0 ? 0 : undefined }} data-testid={`blog-row-${p.slug}`}>
                <SignalBars />
                <span className="mono" style={{ fontSize: 12, color: "#6B6A63", minWidth: 140 }}>
                  {formatDate(p.published_at || p.created_at).toUpperCase()}
                </span>
                <span style={{ flex: "1 1 360px", display: "flex", flexDirection: "column", gap: 6, minWidth: 0 }}>
                  <span className="disp" style={{ fontSize: 22, fontWeight: 700 }}>{p.title}</span>
                  {p.excerpt && <span style={{ fontSize: 15, color: "#4A4F5A" }}>{p.excerpt}</span>}
                </span>
                <span className="chip" style={{ height: 28 }}>
                  {[p.tags?.[0], `${p.read_minutes} min`].filter(Boolean).join(" · ")}
                </span>
              </Link>
            ))
          )}
        </div>
      </section>
    </>
  );
}
